var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.parts)?_c('span',{staticClass:"text-nowrap"},[_vm._v(" "+_vm._s(_vm.parts.date)),(!_vm.dateOnly)?_c('span',[_vm._v(", "+_vm._s(_vm.parts.time))]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }